<template>
  <div class="not_found">
    <div class="cnt">
      <h1>
        <img src="@/assets/img/icon/logo_red.png" alt="giftshow biz" />
        <span class="txt_hidden">giftshow biz</span>
      </h1>
      <p>서비스 이용에<br>불편을 드려 죄송합니다.</p>

      <strong>요청하신 페이지를 찾을 수 없습니다.</strong>

      <p>
        페이지 URL 주소가 잘못 입력 되었거나,<br>
        변경 또는 삭제되어 해당 페이지에 접속할 수 없습니다.<br>
        입력하신 URL주소를 다시 확인해 주시기 바랍니다.
      </p>

      <div class="btn_area">
        <router-link to="/" tag="button" type="button" class="btn md black">
          <span class="txt">홈</span>
        </router-link>
      </div>

      <div class="bg_area">
        <img src="@/assets/img/icon/ico_notFound.png" alt="not found image" />
      </div>
    </div>

    <p class="copy">Copyright ⓒ kt alpha Co., Ltd. All rights reserved</p>
  </div>
</template>

<script>
export default {
  name: 'Notfound',
}
</script>

<style>
</style>
